/* global TweenMax TimelineMax */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

import Message from './Message.jsx';
import Audio from '../../lib/audio';

import Copydeck from '../../data/copydeck.json';
import Sentences from '../../data/sentences.json';
import CrisisActions from '../../actions/CrisisActions';

import { isMobile } from '../../lib/isMobile';

const mobile = isMobile();

const propTypes = {
    mobile: PropTypes.bool.isRequired,
    debug: PropTypes.bool,
    // x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    messages: PropTypes.array,
    elevated: PropTypes.bool,
    play: PropTypes.bool,

    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,

    frameIndex: PropTypes.number.isRequired,
    frameWidth: PropTypes.number.isRequired,
    frameHeight: PropTypes.number.isRequired,

    onGoNextSlide: PropTypes.func.isRequired,
    onGoNextChapter: PropTypes.func.isRequired,
    onOpenLearnMore: PropTypes.func.isRequired,
    onAnimationCall: PropTypes.func,
    onMessageShow: PropTypes.func,

    onStoreMessages: PropTypes.func,

    delay: PropTypes.number,
    animationDelay: PropTypes.number,
    enterFrameDelay: PropTypes.number,
    exitFrameDelay: PropTypes.number,
    messageOffset: PropTypes.number,
    offsetDivider: PropTypes.number,

    onMessengerHeightChange: PropTypes.func.isRequired,

    pastIndex: PropTypes.number,
    pastMessages: PropTypes.array,
    pastAnswers: PropTypes.array,
};

const defaultProps = {
    debug: false,
    messages: [],
    elevated: false,
    play: true,
    delay: 4,
    animationDelay: 1.5,
    enterFrameDelay: 3,
    exitFrameDelay: 3,
    messageOffset: 10,
    offsetDivider: 250,
    onAnimationCall: null,
    onMessageShow: null,
};

const contextTypes = {
    crisis: PropTypes.bool,
    language: PropTypes.string,
    store: PropTypes.object,
    intensity: PropTypes.number,
};

class Messenger extends PureComponent {

    static parseText(content, language, key) {
        let text;

        if (!content.text_mobile || !content.text) {
            console.log('BEWARE NO TEXT EXISTS FOR: ', key, content);
        }
        text = mobile ? content.text_mobile[language] : content.text[language];
        const multiple = (text.match(new RegExp('THUMBS UP', 'g')) || []).length > 1 ? 'multiple' : 'single';
        const thumbUp = `<img src="/img/bubbles/thumbup.png" alt="Thumb up" class="inline-image thumb ${multiple}" />`;
        text = text.replace(new RegExp('THUMBS UP', 'g'), thumbUp);

        return text;
    }

    static parseMessages(messages = [], language) {
        const Texts = _.merge(Copydeck, Sentences);
        const newMessages = [];
        for (let i = 0; i < messages.length; i += 1) {
            const message = _.merge({
                hidden: false,
                choice: false,
                nextChapter: null,
                nextScene: null,
                learnMore: null,
                next: null,
                intensity: null,
                color: null,
                wait: false,
                delay: 0,
                choices: [],
                expand: false,
                crash: false,
                emotion: 'N',
                audible: false,
                crisisSound: null,
                media: {
                    fr: {
                        type: 'null',
                        src: '',
                    },
                    en: {
                        type: 'null',
                        src: '',
                    },
                },
            }, messages[i]);

            const content = Texts[message.key];
            if (!content) {
                // Tracking copydeck errors/missing content
                console.log('BEWARE ERROR loading copy for key : ', message.key);
                continue;
            }

            if (message.choices.length > 0) {
                const choices = message.choices.map((choice) => {
                    const newChoice = _.merge({
                        hidden: false,
                        choice: false,
                        nextChapter: null,
                        nextScene: null,
                        learnMore: null,
                        next: null,
                        finished: false,
                        intensity: null,
                        wait: false,
                        delay: 0,
                        expand: false,
                        crash: false,
                        audible: false,
                    }, choice, Texts[choice.key]);

                    newChoice.text.fr = Messenger.parseText(newChoice, 'fr', choice.key);
                    newChoice.text.en = Messenger.parseText(newChoice, 'en', choice.key);

                    return newChoice;
                });
                message.choices = choices;
            }

            content.text.fr = Messenger.parseText(content, 'fr', message.key);
            content.text.en = Messenger.parseText(content, 'en', message.key);

            newMessages.push(_.merge({}, message, content));
        }
        return newMessages;
    }

    // callNext(callback, delay = 0) {
    //     console.log('callNext', delay);
    //     TweenMax.killDelayedCallsTo(this.previousCallback);
    //     this.previousCallback = callback;
    //     const delayInSeconds = delay > 0 ? delay / 1000 : 0;
    //     TweenMax.delayedCall(delayInSeconds, this.previousCallback);
    // }

    callNext(callback, delay = 0) {
        // console.log('callnext');
        if (this.messageTimeline !== null) {
            this.messageTimeline.kill();
            TweenMax.killTweensOf(this.messageTimeline);
            this.messageTimeline = null;
        }

        const fake = { low: 0 };
        const delayInSeconds = delay > 0 ? delay / 1000 : 0;
        this.messageTimeline = new TimelineMax();

        this.messageTimeline.to(fake, 0, {
            low: 1,
            delay: delayInSeconds,
            repeat: 0,
            onComplete: () => {
                // console.log('complete');
                callback();
            },
        });
    }


    constructor(props) {
        super(props);

        this.DOMMessages = {};

        this.messages = null;
        this.leon = null;
        this.typingMessage = null;
        this.messagesTimeout = null;

        this.previousCallback = null;

        // this.messageTimeout = null;
        // this.animationTimeout = null;

        this.messageTimeline = null;
        this.animationTimeline = null;

        this.leonRect = null;

        this.callNext = this.callNext.bind(this);
        this.renderMessage = this.renderMessage.bind(this);

        this.updateMessageList = this.updateMessageList.bind(this);
        this.updateMessageTimer = this.updateMessageTimer.bind(this);

        this.onIndexChange = this.onIndexChange.bind(this);
        this.onResume = this.onResume.bind(this);
        this.onAnswerClick = this.onAnswerClick.bind(this);
        this.onMessageClick = this.onMessageClick.bind(this);

        this.animate = this.animate.bind(this);
        this.animateMessages = this.animateMessages.bind(this);

        this.audios = {
            newMessage: new Audio('/audio/28nov/general-ouverture-boite-dialogue.mp3'),
            newCharacter: new Audio('/audio/28nov/general-bulle-texte.mp3'),
            answerA: new Audio('/audio/28nov/general-bouton-haut.mp3'),
            answerB: new Audio('/audio/28nov/general-bouton-bas.mp3'),
        };

        this.state = {
            currentMessages: Messenger.parseMessages(props.messages),
            currentIndex: 0,
            messageBoxDelay: this.props.delay,
            resumeChanged: false,
            displayedMessages: [],
            // displayedHeights: [],
            expanded: false,
            crisis: false,
            answers: [],
            emotion: 'N',
        };
    }

    componentDidMount() {
        this.messagesTimeout = null;
        this.updateMessageList(null, true);
    }

    componentWillReceiveProps(nextProps) {
        const messagesChanged = !_.isEqual(this.props.messages, nextProps.messages);
        const state = {};

        if (messagesChanged) {
            state.currentMessages = Messenger.parseMessages(nextProps.messages);
            if (nextProps.messages.length > 0) {
                state.currentIndex = nextProps.pastIndex;
                state.displayedMessages = nextProps.pastMessages;
                state.answers = nextProps.pastAnswers;
                state.expanded = false;
            } else {
                state.currentIndex = 0;
                state.displayedMessages = [];
                state.displayedHeights = [];
                state.expanded = false;
            }
        }

        if (_.values(state).length) {
            this.setState(state);
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const playing = this.props.play === true;
        const currentMessagesChanged = prevState.currentMessages !== this.state.currentMessages;
        const playChanged = prevProps.play !== this.props.play;

        const verticalPositionChanged = prevProps.y !== this.props.y;
        const indexChanged = prevState.currentIndex !== this.state.currentIndex;
        const resumeChanged = prevState.resumeIndex !== this.state.resumeIndex;
        const expandedChanged = prevState.expanded !== this.state.expanded;

        const sizeChanged =
            prevProps.frameWidth !== this.props.frameWidth
            || prevProps.frameHeight !== this.props.frameHeight
            || prevProps.width !== this.props.width
            || prevProps.height !== this.props.height;

        if (verticalPositionChanged) {
            this.animatePaused(true);
        }

        if (indexChanged) {
            this.props.onMessageShow(null, this.state.currentIndex);
        }

        // Resume automagically on play state change
        if (playChanged) {
            if (playing) {
                this.updateMessageList(this.state.currentIndex, false, true, true, 1000);
            }
        // Resume on frame changed
        } else if (currentMessagesChanged && playing) {
            const message = this.state.currentMessages[this.state.currentIndex];

            if (message && (message.key === 'end_scene' || message.key === 'end_chapter') && this.state.currentMessages.length > 1) {
                this.animateHideAll(0);
                this.animate(0);
                console.log('skip it', message);
            } else {
                if (this.messageTimeline !== null) {
                    this.messageTimeline.kill();
                    this.messageTimeline = null;
                }
                this.animateHideAll(0);
                this.updateMessageList(this.state.currentIndex, true);
            }

        // Resume on resume :)
        } else if (resumeChanged && this.state.resumeIndex !== null) {
            // console.log('resume', this.state.resumeIndex);
            this.setState({
                resumeIndex: null,
            }, () => {
                // special case where an answer leads to en end_scene or end_chapter
                const message = this.getMessage(this.state.currentIndex);
                if (message && (message.nextChapter !== null || message.nextScene !== null)) {
                    this.updateMessageList(this.state.currentIndex, false, true, true);
                } else {
                    this.updateMessageList(this.state.currentIndex, true, true, true);
                }
            });
        // Move on to next message
        } else if (indexChanged) {
            // console.log('for real auto next');
            this.updateMessageList(null, true);
        }

        if (expandedChanged || sizeChanged) {
            this.animateExpand();
        }

        if (sizeChanged) {
            this.animateMessages(false, true);
        }
    }

    componentWillUnmount() {
        if (this.messageTimeline !== null) {
            this.messageTimeline.kill();
            this.messageTimeline = null;
        }

        Object.keys(this.audios).forEach((name) => {
            this.audios[name].destroy();
            this.audios[name] = null;
        });
    }

    onResume(index) {
        this.setState({
            currentIndex: index,
            resumeIndex: index,
        });
    }

    onAnswerClick(e, key, nextIndex, buttonIndex) {
        const answers = this.state.answers.concat();
        answers.push(key);
        this.setState({
            answers,
        }, () => {
            if (buttonIndex % 2 === 0) {
                this.audios.answerB.play(0);
            } else {
                this.audios.answerA.play(0);
            }
            this.onMessageClick(e, 'resume', nextIndex);
        });
    }

    onMessageClick(e, type, value) {
        switch (type) {
        case 'arrow':
        case 'nextScene':
            if (this.props.onGoNextSlide) {
                this.props.onGoNextSlide();
            }
            break;
        case 'nextChapter':
            if (this.props.onGoNextChapter) {
                this.props.onGoNextChapter(value);
            }
            break;
        case 'learnMore':
            if (this.props.onOpenLearnMore !== null) {
                const content = {
                    key: value,
                };
                this.props.onOpenLearnMore(value, content);
            }
            break;
        case 'resume':
            if (this.onResume) {
                this.onResume(value);
            }
            break;
        default:
            break;
        }
    }

    // Position in structure

    onIndexChange() {
        const { currentIndex } = this.state;
        const nextIndex = this.getNextIndex(currentIndex);
        const nextMessage = this.getMessage(nextIndex);

        if (nextMessage && nextMessage.animation) {
            if (this.props.onAnimationCall) {
                this.props.onAnimationCall(nextMessage.animation);
            }
        }

        this.setState({
            currentIndex: nextIndex,
        });
    }

    getNextIndex(idx = null, relativeIndex = false) {
        const { currentMessages } = this.state;
        if (idx === null) return null;
        let currentMessage = null;
        if (relativeIndex) {
            currentMessage = this.getDisplayedMessage(idx);
        } else {
            currentMessage = this.getMessage(idx);
        }
        const nextIndex = idx + 1;

        if (currentMessage) {
            if (typeof currentMessage.choice !== 'undefined'
                && currentMessage.choice === true) {
                // console.log('CHOICE!', nextIndex, currentMessage.choice);
                return nextIndex;
            } else if (typeof currentMessage.next !== 'undefined'
                && currentMessage.next !== null) {
                const index = currentMessages.map(o => (o.key)).indexOf(currentMessage.next);
                // console.log('NEXT!', nextIndex, index, currentMessage.next);
                if (index > 0) return index;
                return nextIndex;
            } else if (typeof currentMessages[nextIndex] !== 'undefined') {
                return nextIndex;
            }
            return nextIndex;
        } else if (typeof currentMessages[nextIndex] !== 'undefined') {
            return nextIndex;
        }
        return null;
    }

    getDisplayedIndex(key = null) {
        const messages = this.getDisplayedMessages();
        if (key === null) return null;
        return messages.map(o => (o.key)).indexOf(key);
    }

    getKey(idx = null) {
        const { currentMessages } = this.state;
        if (idx === null) return null;
        if (typeof currentMessages[idx] === 'undefined') return null;
        return currentMessages[idx].key || null;
    }

    getMessage(idx = null) {
        const { currentMessages } = this.state;
        if (idx === null) return null;
        if (typeof currentMessages[idx] === 'undefined') return null;
        return currentMessages[idx];
    }

    getDisplayedMessage(idx = null) {
        const currentMessages = this.getDisplayedMessages();
        if (idx === null) return null;
        if (typeof currentMessages[idx] === 'undefined') return null;
        return currentMessages[idx];
    }

    getDisplayedMessages() {
        return this.state.currentMessages.filter(
            o => (this.state.displayedMessages.indexOf(o.key) !== -1),
        );
    }

    isAnimated(message) {
        const isLeon = this.isLeon(message);
        if (!message.command && !isLeon) return true;
        return false;
    }

    // eslint-disable-next-line class-methods-use-this
    isLeon(message) {
        return !message.character
            || message.character.toLowerCase() === 'leon'
            || message.character.toLowerCase() === 'leongif'
            || message.key.toLowerCase().indexOf('graph') !== -1
            || message.key.toLowerCase().indexOf('video') !== -1
            || message.key.toLowerCase().indexOf('share') !== -1
            || message.key.toLowerCase().indexOf('savoirplus') !== -1
            || message.key.toLowerCase().indexOf('partage') !== -1;
    }

    animate(forcedDelay = null) {
        this.prepareAnimateMessages();
        if (this.animationTimeline !== null) {
            // console.log('called the animation star');
            this.animationTimeline.kill();
            TweenMax.killTweensOf(this.animationTimeline);
            this.animationTimeline = null;
        }

        this.animationTimeline = new TimelineMax();
        const fake = { low: 0 };
        this.animationTimeline.to(fake, 0, {
            low: 1,
            delay: forcedDelay !== null ? forcedDelay : this.props.animationDelay,
            repeat: 0,
            onComplete: this.animateMessages,
        });
    }

    prepareAnimateMessages() {
        const messages = this.getDisplayedMessages();
        if (messages.length > 0) {
            // console.log('booya');
            const messageList = messages.reverse();
            const message = messageList[0];
            const DOMmessage = this.DOMMessages[message.key];
            if (DOMmessage !== null) {
                TweenMax.set(DOMmessage, {
                    alpha: 0,
                    y: 300,
                });
            }
        }
    }

    animateMessages(showAll = false, resize = false) {
        const { frameHeight, messageOffset, offsetDivider } = this.props;
        const { expanded } = this.state;
        // const currentKey = this.getKey(currentIndex);
        const messages = this.getDisplayedMessages();
        const messageList = messages.reverse();
        const heights = this.updateHeight().reverse();
        const margin = Math.floor(frameHeight / offsetDivider);
        const offset = Math.floor(frameHeight / offsetDivider);

        const messagesOffset = expanded ? this.props.height * 0.5 : 0;
        const max = this.props.height - messagesOffset - 11; // top margin for hidden messages
        // console.log(max, this.props.height, this.props.frameHeight, messagesOffset);

        // let height = 0;
        let height = Math.floor(this.props.y) + (expanded ? -10 : 0);
        let fullHeightMinusFirst = 0;

        if (height > 0) {
            // showAll = true;
        }

        const timeline = new TimelineMax();

        for (let i = 0; i < messageList.length; i += 1) {
            const message = messageList[i];
            const DOMmessage = this.DOMMessages[message.key];
            const offset2 = message.hidden ? 0 : messageOffset;
            // eslint-disable-next-line no-continue
            if (DOMmessage === null) continue;
            if (i === 0) {
                timeline.fromTo(DOMmessage, 0.5, {
                    alpha: resize ? 1 : 0,
                    y: resize ? height : 300,
                }, {
                    alpha: 1,
                    y: height - offset,
                    onStart: () => {
                        if (message.hidden === 'false'
                            || message.next === 'next_scene'
                            || message.next === 'next_chapter') {
                            return;
                        }
                        if (messageList.length === 2 && message.hidden === false
                            && messageList[1].hidden === true && this.audios.newMessage) {
                            this.audios.newMessage.play();
                        } else if ((messageList.length === 1 || message.audible === true)
                            && !message.hidden && this.audios.newMessage) {
                            this.audios.newMessage.play();
                        } else if (message.audible === 'newCharacter' && this.audios.newCharacter) {
                            this.audios.newCharacter.play();
                        }
                    },
                }, 0);
                height -= (heights[i] ? heights[i] : offset2) + margin + offset;
            } else {
                let maxFour = i < Math.min(Math.max(messageList.length - 4, 4), 4);

                if (this.props.y > 1) {
                    maxFour = true;
                }
                const visible = maxFour
                    && (height - heights[i]) > -max
                    && height < 1;

                let opacity = 0;
                if (!visible && !expanded) {
                    if (height > 1) {
                        opacity = 0.33;
                    }
                }

                timeline.to(DOMmessage, 0.5, {
                    alpha: visible || showAll ? 1 : opacity,
                    y: height,
                }, 0);
                height -= (heights[i] ? heights[i] : offset2) + margin;
            }

            if (i < messageList.length - 1) {
                fullHeightMinusFirst += heights[i] + margin;
            }
        }

        this.props.onMessengerHeightChange(Math.abs(fullHeightMinusFirst));
    }

    animatePaused() {
        if (this.animationTimeline !== null) {
            this.animationTimeline.kill();
            this.animationTimeline = null;
        }
        const { expanded } = this.state;
        const { frameHeight, messageOffset, offsetDivider } = this.props;
        const messages = this.getDisplayedMessages();
        const messageList = messages.reverse();
        const heights = this.updateHeight().reverse();
        const margin = Math.ceil(frameHeight / offsetDivider);
        let height = Math.floor(this.props.y) + (expanded ? -10 : 0);
        let fullHeightMinusFirst = 0;

        const messagesOffset = expanded ? this.props.height * 0.5 : 0;
        const max = this.props.height - messagesOffset - 11; // top margin for hidden messages

        const timeline = new TimelineMax();

        for (let i = 0; i < messageList.length; i += 1) {
            const message = messageList[i];
            const DOMmessage = this.DOMMessages[message.key];

            let maxFour = i < Math.min(Math.max(messageList.length - 4, 4), 4);
            if (this.props.y > 1) {
                maxFour = true;
            }
            const visible = maxFour
                && (height - heights[i]) > -max
                && height < 1;

            let opacity = 0;
            if (!visible && !expanded) {
                if (height > 1) {
                    opacity = 0.33;
                }
            }

            timeline.to(DOMmessage, 0.5, {
                alpha: visible ? 1 : opacity,
                y: height,
            }, 0);

            const offset = message.hidden ? 0 : messageOffset;
            height -= (heights[i] ? heights[i] : offset) + margin;

            if (i < messageList.length - 1) {
                fullHeightMinusFirst += heights[i] + margin;
            }
        }

        this.props.onMessengerHeightChange(Math.abs(fullHeightMinusFirst));
    }

    animateHideAll(delay = 0) {
        // console.log('kill em all');
        if (this.animationTimeline !== null) {
            this.animationTimeline.kill();
            this.animationTimeline = null;
        }
        const { expanded } = this.state;
        const { frameHeight, messageOffset, offsetDivider } = this.props;
        const messages = this.getDisplayedMessages();
        const messageList = messages.reverse();
        const heights = this.updateHeight().reverse();
        const margin = Math.ceil(frameHeight / offsetDivider);
        let height = Math.floor(this.props.y) + (expanded ? -10 : 0);
        let fullHeightMinusFirst = 0;

        for (let i = 0; i < messageList.length; i += 1) {
            const message = messageList[i];
            const DOMmessage = this.DOMMessages[message.key];
            TweenMax.set(DOMmessage, {
                alpha: 0,
                y: height,
            });
            const offset = message.hidden ? 0 : messageOffset;
            height -= (heights[i] ? heights[i] : offset) + margin;

            if (i < messageList.length - 1) {
                fullHeightMinusFirst += heights[i] + margin;
            }
        }

        this.props.onMessengerHeightChange(Math.abs(fullHeightMinusFirst));
    }

    animateExpand() {
        if (this.state.expanded) {
            this.expandLeon();
        } else {
            this.shrinkLeon();
        }
    }

    expandLeon() {
        if (!this.messages || !this.leon) return;

        const { frameWidth, height, mobile } = this.props;

        if (this.leonRect === null) {
            this.leonRect = this.leon.getBoundingClientRect();
        }

        const offsetY = mobile ? 0.18 : 0.25;

        const timeline = new TimelineMax();

        timeline.to(this.messages, 1, {
            y: `-${height * 0.5}px`,
        }, 0);
        timeline.to(this.leon, 1, {
            scale: 3.5,
            y: `-${height * offsetY}px`,
            x: `${(frameWidth * 0.5) - (this.leonRect.width / 2)}px`,
        }, 0);
    }

    shrinkLeon() {
        if (!this.messages || !this.leon) return;

        const timeline = new TimelineMax();

        timeline.to(this.messages, 1, {
            alpha: 0,
        }, 0);

        timeline.to(this.leon, 1, {
            scale: 1,
            y: 0,
            x: 0,
        }, 0);

        timeline.to(this.messages, 1, {
            y: 0,
        }, 1);

        timeline.to(this.messages, 1, {
            alpha: 1,
        }, 2);
    }

    updateHeight() {
        return this.getDisplayedMessages().map((message) => {
            if (message !== null
                && typeof this.DOMMessages[message.key] !== 'undefined'
                && this.DOMMessages[message.key] !== null
                && message.hidden === false) {
                return this.DOMMessages[message.key].offsetHeight;
            }
            return 0;
        });
    }
    // eslint-disable-next-line max-len
    updateMessageList(nextIdx = null, animate = false, queueNext = true, skip = false, delay = null) {
        // console.log('bro message list');
        const nextMessage = this.getMessage(nextIdx);
        const currentMessage = this.getMessage(this.state.currentIndex);

        let expanded = this.state.expanded;
        // let crisis = this.state.crisis;

        const displayedMessages = this.state.displayedMessages.concat();
        if (currentMessage !== null && currentMessage.key) {
            if (displayedMessages.length > 0) {
                if (displayedMessages[displayedMessages.length - 1] !== currentMessage.key) {
                    displayedMessages.push(currentMessage.key);
                }
            } else {
                displayedMessages.push(currentMessage.key);
            }

            if (currentMessage.expand === true || currentMessage.expand === false) {
                expanded = currentMessage.expand;
            }
            // if (currentMessage.crisis === true || currentMessage.crisis === false) {
            //     crisis = currentMessage.crisis;
            // }
        }

        if (this.props.onStoreMessages) {

            if (displayedMessages && displayedMessages.length > 0) {
                // console.log('STORAGE STEP', displayedMessages, this.state.answers, this.state.currentIndex);
                this.props.onStoreMessages(displayedMessages, this.state.answers, this.state.currentIndex);
            }

        }

        this.setState({
            displayedMessages,
            expanded,
            // crisis,
        }, () => {
            if (skip && nextMessage && (nextMessage.nextChapter || nextMessage.nextScene)) {
                this.prepareAnimateMessages();
                this.queueNext(nextMessage, 0.8);
            } else {
                if (queueNext) {
                    this.updateMessageTimer(delay);
                }
                if (animate) {
                    // console.log('animate', nextMessage);
                    this.animate();
                }
            }
        });
    }

    updateMessageTimer(forcedDelay = null) {
        // console.log('bro timer');
        const props = this.props;
        const state = this.state;
        const context = this.context;

        const messages = props.messages;
        const message = this.getMessage(this.state.currentIndex);
        const nextIndex = this.getNextIndex(this.state.currentIndex);
        const nextMessage = this.getMessage(nextIndex);

        let messageDelay =
            (message && message.delay ? message.delay : this.props.delay)
            * 1000;

        if (this.state.currentIndex === 0) {
            messageDelay = this.props.enterFrameDelay * 1000;
        }

        if (message && this.isAnimated(message)) {
            messageDelay = (message.delay ? message.delay : this.props.delay) * 1200;
        }

        if (forcedDelay !== null) {
            messageDelay = forcedDelay;
        }

        // if (this.messagesTimeout) {
        //     clearTimeout(this.messagesTimeout);
        //     this.messagesTimeout = null;
        // }

        if (message) {
            if (message.intensity !== null) {
                context.store.dispatch(CrisisActions.updateIntensity(message.intensity));
            }

            if (message.crisisSound !== null) {
                context.store.dispatch(CrisisActions.updateCrisisSound(false));
            }

            if (message.crisis === true && this.state.crisis === false) {
                context.store.dispatch(CrisisActions.updateCrisis(true));
                context.store.dispatch(CrisisActions.updateCrisisSound(true));
                console.log('it\'s on');
                this.setState({
                    crisis: true,
                });
            } else if (message.crisis === false && this.state.crisis === true) {
                context.store.dispatch(CrisisActions.updateCrisis(false));
                console.log('it\'s off');
                this.setState({
                    crisis: false,
                });
            }
        }

        if (nextMessage !== null
            && props.play
            && messages.length > 0
            && state.currentIndex < messages.length) {
            // Queue next auto or choice

            if (message && message.wait === true && message.command === false) {
                this.queueNext(nextMessage, message.delay);
            } else if (message
                && (message.wait === true
                || message.command === true)) {
                return;
            }
            // Default path to next
            this.messagesTimeout = this.callNext(this.onIndexChange, messageDelay);
        }

        // Time out to next automatically
        if (message && nextMessage === null) {
            if (!this.props.debug) {
                messageDelay = (message && message.delay ?
                    message.delay : this.props.exitFrameDelay) * 1000;

                console.log('go on next slide', message, messageDelay);
                this.messagesTimeout =
                    this.callNext(this.props.onGoNextSlide, messageDelay);
            }
        }

        // console.log('delat2', messageDelay, forcedDelay);
    }

    queueNext(message = null, messageDelay = 1) {
        if (message !== null && message.nextChapter) {
            this.messagesTimeout = this.callNext(() => {
                this.props.onGoNextChapter(message.nextChapter);
            }, 3000);
        } else if (message !== null && message.nextScene) {
            this.messagesTimeout = this.callNext(this.props.onGoNextSlide, messageDelay * 1000);
        } else {
            this.messagesTimeout = this.callNext(this.onIndexChange, messageDelay);
        }

        // console.log('delat3', messageDelay);
    }

    // eslint-disable-next-line class-methods-use-this
    renderRightFace(character, visible) {
        const className = classNames({
            face: true,
            [`face-${character.toLowerCase()}`]: true,
            hidden: !visible,
        });

        return (
            <div className={className} />
        );
    }

    renderMessage(message, index) {
        if (!message
            || message.finished === true) {
            return null;
        }
        const messageList = this.getDisplayedMessages();
        let current = false;
        if (index === messageList.length - 1) {
            current = true;
        }

        const nextIndex = this.getNextIndex(index, true);
        const nextMessage = this.getMessage(nextIndex);

        const nextButtonIndex = this.state.currentMessages.map(o => (o.key)).indexOf(message.next);

        const visible = message !== null && message.hidden !== true;
        const text = message.text[this.context.language] || '';
        let hiddenArrow = false;
        if (text) {
            // hiddenArrow = text.indexOf('Thumb') > -1;
        }
        if (message.command === true) {
            hiddenArrow = true;
        }
        const isLeon = this.isLeon(message);
        const isAnimated = this.isAnimated(message);

        // Heads
        let rightFaceVisible = true;
        if (message !== null
            && nextMessage !== null
            && message.character
            && nextMessage.character
            && message.character === nextMessage.character
            && !current) {
            rightFaceVisible = false;
        }
        const rightFace = !isLeon ?
            this.renderRightFace(message.character, rightFaceVisible) : null;

        const className = classNames({
            'message-box': true,
            elevated: this.props.elevated,
            'is-extra-cast': !isLeon,
            'hidden-arrow': hiddenArrow,
            'has-choices': message.choices && message.choices.length > 0,
            [message.character.toLowerCase()]: true,

        });

        const style = !visible ? { height: 0 } : {};

        return (
            <div className={className}>
                <div className="text" ref={(el) => { this.DOMMessages[message.key] = el; }} style={style}>
                    { visible === true ? (
                        <Message
                            message={message}
                            nextMessage={nextMessage}
                            nextIndex={nextIndex}
                            index={index}
                            nextButtonIndex={nextButtonIndex}
                            current={current}

                            answers={this.state.answers}
                            currentMessages={this.state.currentMessages}

                            isAnimated={isAnimated}
                            isLeon={isLeon}
                            play={this.props.play}
                            expanded={this.state.expanded}

                            onAnswerClick={this.onAnswerClick}
                            onMessageClick={this.onMessageClick}
                        />
                    ) : null }
                    { rightFace }
                </div>
            </div>
        );
    }

    // preloadEmotions() {
    //     if (typeof Image !== 'undefined') {
    //         Object.values(emotions).forEach((emotion) => {
    //             const image = new Image();
    //             image.onload = (e) => {
    //                 // console.log(e);
    //             };
    //             image.src = `/img/leon/${emotion}.png`;
    //             return image;
    //         });
    //     }
    // }

    render() {
        const { y } = this.props;
        const messageList = this.getDisplayedMessages();
        const messages = messageList.map(this.renderMessage);

        const leonClassName = classNames({
            'leon-face': true,
            // [`emotion-${this.state.emotion}`]: true,
        });

        return (
            <div className="messenger">
                <div className="messages" ref={(el) => { this.messages = el; }}>
                    { messages }
                    { y ? (
                        <button className="messages-under-indicator" />
                    ) : null }
                </div>
                <div ref={(el) => { this.leon = el; }} className={leonClassName} />
            </div>
        );
    }
}

// <div ref={(el) => { this.leonFaceSwap = el; }} className={leonClassName} />

Messenger.propTypes = propTypes;
Messenger.defaultProps = defaultProps;
Messenger.contextTypes = contextTypes;

module.exports = Messenger;



// WEBPACK FOOTER //
// ./js/components/partials/Messenger.jsx